import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';
import Cuotas from './PrintModal/Cuotas';

import HistorialPago from './PrintModal/HistorialPago';


const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class PrintModal extends React.Component {
    render() {


        return (
            <Modal
                title={"Cuentas por pagar a proveedores"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1100}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>,
                    <Button
                      key="ok"
                      type="primary"
                       //loading={this.props.saveLoading}
                      onClick={() => this.props.onImprimir(this.props.formValues.idDocumentoElctronico)}  

                    >
                      Imprimir
                    </Button>,
                    
                ]}
            >
                <Form>

                    
                <div className="row">
                        <div className="col-md-4">
                            <Form.Item label="Documento">
                            <Input readOnly
                                    value={this.props.formValues.DocumentoCliente}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-8">
                            <Form.Item label="Proveedor">
                                <Input readOnly
                                    value={this.props.formValues.RazonSocialClientemento}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
              
                        <div className="col-md-3">
                            <Form.Item label="Factura">
                                <InputGroup compact>
                                    <Input readOnly
                                        value={this.props.formValues.NumeroDocumento}
                                    />
                                   
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Monto">
                            <Input readOnly
                                    value={this.props.formValues.Monto}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-3">
                            <Form.Item label="Moneda">
                                <Input readOnly
                                    value={this.props.formValues.Moneda}
                                />
                            </Form.Item>
                        </div>
                    </div>
        
             
                    <div className="row">
                        <div className="col-md-12 form-group">
                             <Tabs>
                                <TabPane tab="Cuotas" key="1">
                                    <Cuotas
                                        dataSource={this.props.formValues.detalles}
                                    />
                                </TabPane>
                        </Tabs>  
                        </div>

                        <div className="col-md-12 form-group">
                             <Tabs>
                                <TabPane tab="Historial de Pagos" key="2">
                                    <HistorialPago
                                        dataSource={this.props.formValues.lst_historialPago}
                                    />
                                </TabPane>
                        </Tabs>  
                        </div>
                    </div>
               
                </Form>
            </Modal>
        );
    }
}